<app-topbar></app-topbar>
<div class="container mr-top-56">
   <h1 class="mainhdng mr-bttm-30">Products & Subscriptions</h1>
   <a routerLink="/add-product-subscriptions/{{selected_product}}" class="gobck"><img src="assets/images/gobck.png"> Go Back</a>
   <!-- Payment Detail -->
   <div class="mobshowtitle">
      <!-- <div *ngFor = "let year of yearList">
         {{year}}
      </div> -->
      <h3 class="pyhdng">You selected a {{packageDetail['package_name']}} plan.</h3>
      <p class="boxpara_bold">You selected {{license_count}} users. </p>
   </div>
   <div class="common row mr-top-68 paymentdtlsrow frMbl">
      <div class="col-md-6 col-sm-12 col-xs-12 left_side">
         <div class="mobhidetitle">
			 <h3 class="pyhdng">You selected a <span class="basicplan">{{packageDetail['package_name']}} plan.</span></h3>
            <p class="boxpara_bold">You selected {{license_count}} users. </p>
         </div>
        <div class="paymenthdng_div">
           <!--  <h1 class="paymenthdng">Payment Details</h1>-->
         </div>
         <!-- Payment Details Form -->
         <div class="billingform">
            
            <form [formGroup]="form" (ngSubmit)="submit()">
				<div class="fsecttbill">
				<h4 class="form_subheading">Billing INFORMATION</h4>
            <div class="form-group row">
               <div class="col-md-6 col-sm-6 col-xs-6">
                  <input type="text" class="form-control" id="pay_name" placeholder="Enter First Name" formControlName="firstname">
                  <div *ngIf="submitted && f.firstname.invalid">
                     <span class="inputValidation" *ngIf="f.firstname.errors.required">First Name is required.</span>
                  </div>
               </div>
               <div class="col-md-6 col-sm-6 col-xs-6">
                  <input type="text" class="form-control" id="pay_name" placeholder="Enter Last Name" formControlName="lastname">
                  <div *ngIf="submitted && f.lastname.invalid">
                     <span class="inputValidation" *ngIf="f.lastname.errors.required">Last Name is required.</span>
                  </div>
               </div>
            </div>
            <div class="form-group row">
               <div class="col-md-6 col-sm-6 col-xs-6">
                  <input type="email" class="form-control" placeholder="Enter email" formControlName="email" readonly>
                  <div *ngIf="submitted && f.email.invalid">
                     <span class="inputValidation" *ngIf="f.email.errors.required">Email is required.</span>
                  </div>
               </div>
               <div class="col-md-6 col-sm-6 col-xs-6">
                  <input type="text" class="form-control"  placeholder="Enter Phone" formControlName="mobile_no" maxlength="15" minlength="10" mask='(000) 000-0000'>
                  <div *ngIf="submitted && f.mobile_no.invalid">
                     <span class="inputValidation" *ngIf="f.mobile_no.errors.required">Phone is required.</span>
                     <span class="inputValidation" *ngIf="f.mobile_no.errors.minlength">Phone is not valid.</span>
                  </div>
               </div>
            </div>
            <div class="form-group row">
               <div class="col-md-12 col-sm-12 col-xs-12">
                  <input type="text" class="form-control" placeholder="Address" formControlName="address">
                  <div *ngIf="submitted && f.address.invalid">
                     <span class="inputValidation" *ngIf="f.address.errors.required">Address is required.</span>
                  </div>
               </div>
            </div>
            <div class="form-group row">
               <div class="col-md-6 col-sm-6 col-xs-6">
                  <select class="pymntmthds form-control" id="country" autocomplete="off" formControlName="country"
                     (change)="changeState($event.target.value)"
                     >
                     <option value="">Select Country</option>
                     <option *ngFor="let country of countries" [value]="country.id">
                     {{country.name}}</option>
                  </select>
                  <div *ngIf="submitted && f.country.invalid">
                     <span class="inputValidation" *ngIf="f.country.errors.required">Country is required.</span>
                  </div>
               </div>
               <div class="col-md-6 col-sm-6 col-xs-6">
                  <div *ngIf="stateLoading else selectState">
                     <img src="assets/images/loading.gif" class="loading_gif"/>
                     </div>   
                     <ng-template #selectState>
                  <select class="pymntmthds form-control" id="state" autocomplete="off" formControlName="state" 
                     >
                     <option value="">Select State</option>
                     <option *ngFor="let state of states" [value]="state.id">
                     {{state.name}}
                     </option>
                  </select>
                  </ng-template>
                  <div *ngIf="submitted && f.state.invalid">
                     <span class="inputValidation" *ngIf="f.state.errors.required">State is required.</span>
                  </div>
               </div>
            </div>
            <div class="form-group row">
               <div class="col-md-6 col-sm-6 col-xs-6">
                  <input type="text" class="form-control" placeholder="City" formControlName="city">
                  <div *ngIf="submitted && f.city.invalid">
                     <span class="inputValidation" *ngIf="f.city.errors.required">City is required.</span>
                  </div>
               </div>
               <div class="col-md-6 col-sm-6 col-xs-6">
                  <input type="text" class="form-control" placeholder="Zip Code" formControlName="zip">
                  <div *ngIf="submitted && f.zip.invalid">
                     <span class="inputValidation" *ngIf="f.zip.errors.required">Zip is required.</span>
                  </div>
               </div>
            </div>
				</div>
				 <div class="fsecttbill2 mr-top-76">
            <h4 class="form_subheading">PAYMENT INFORMATION</h4>
            <!-- Credit Card Form -->
            <div class="common crditcrdfrm">
               <div class="form-group">
                  <input type="text" class="form-control" id="credit_name" placeholder="Enter name" formControlName="card_name">
                  <div *ngIf="submitted && f.card_name.invalid">
                     <span class="inputValidation" *ngIf="f.card_name.errors.required">Name is required.</span>
                  </div>
               </div>
               <div class="form-group">
                  <input type="text" class="form-control" id="credit_number" placeholder="Enter Credit Number" formControlName="card_number" maxlength="16">
                  <div *ngIf="submitted && f.card_number.invalid">
                     <span class="inputValidation" *ngIf="f.card_number.errors.required">Credit Number is required.</span>
                  </div>
               </div>
               <div class="form-group row">
                  <div class="col-md-4 col-sm-4 col-xs-4">
                     <select id="expYear" class="pymntmthds form-control" placeholder="324" formControlName="exp_year"
                        autocomplete="off" >
                        <option value="">Select Year</option>
                        <option *ngFor = "let year of yearList" value="{{year.value}}">{{year.year}}</option>
                     </select>
                     <div *ngIf="submitted && f.exp_year.invalid">
                        <span class="inputValidation" *ngIf="f.exp_year.errors.required">Card Expiry is required.</span>
                     </div>
                  </div>
                  <div class="col-md-4 col-sm-4 col-xs-4">
                     <select id="card_expiry_date" class="pymntmthds form-control" placeholder="324"
                        autocomplete="off" formControlName="exp_month">
                        <option value="">Select Month</option>
                        <option value="1">01</option>
                        <option value="2">02</option>
                        <option value="3">03</option>
                        <option value="4">04</option>
                        <option value="5">05</option>
                        <option value="6">06</option>
                        <option value="7">07</option>
                        <option value="8">08</option>
                        <option value="9">09</option>
                        <option value="10">10</option>
                        <option value="11">11</option>
                        <option value="12">12</option>
                     </select>
                     <div *ngIf="submitted && f.exp_month.invalid">
                        <span class="inputValidation" *ngIf="f.exp_month.errors.required">Card Expiry is required.</span>
                     </div>
                  </div>
                  <div class="col-md-4 col-sm-4 col-xs-4">
                     <input type="text" class="form-control" placeholder="CVV" formControlName="card_cvv" maxlength="4">
                     <div *ngIf="submitted && f.card_cvv.invalid">
                        <span class="inputValidation" *ngIf="f.card_cvv.errors.required">CVV is required.</span>
                     </div>
                  </div>
               </div>
               <span class="inputValidation">{{StripeCardEror}}</span>
            </div>
            <div *ngIf="ListCardDiv">
               <div class="col-md-12">
                  <div class="form-group row d-block">
                     
                        <h4 class="form_subheading">SELECT CARD</h4>
                        <div class="text-success text-center">
                        </div>
                        <div *ngFor="let card of Cards">
                           <div class="row frMbl resCardSec" style="margin-bottom: 10px;">
                              <div class="col-md-1 crdSlct"><input type="checkbox" class="stripe_id_card" formControlName="user_card_id" name="user_card_id" binary="true" (change) = "selectCard($event)"
                                 value="{{card.card_id}}"></div>
                              <div class="col-md-2 crdImg"><i class="fa fa-credit-card"
                                 style="font-size:40px;color:#1CABA0"></i></div>
                              <div class="col-md-3 crdBrnd">{{card.card_brand}}</div>
                              <div class="col-md-5 crdDigit">***********{{card.card_last4}}</div>
                           </div>
                        </div>
                        <div class="row">
                           <div class="col-md-4">
                              <div class="payloader" style="position:relative;float:left;">
                                 <input *ngIf="ShowPayNow" type="submit" name="submit" value="Pay Now"
                                    id="Pay_button" class="submit action-button mr-top-25" style="margin-top: 25px;">
                                 <img *ngIf="ShowLoading" class="loaderimage" src="assets/images/loader.gif"
                                    style="position:relative;float:left;margin-top: 30px;" />
                              </div>
                           </div>
                        </div>
                     
                  </div>
               </div>
            </div>
				</div>
            <!-- Credit Card Form -->
            <!-- Credit Card Section -->
           <div class="boxsize">
            <div class="form-group text-left divide50 mt-3">
               <button type="submit" class="plcordrbtn">Place Order</button>
            </div>
            <div class="common mr-20-32 divide50">
               <p class="privcttxt">By clicking the button, you agreed to the <a href="javascript:void(0)" routerLink ="/terms" target="blank">Terms and Conditions</a></p>
            </div>
         </div>
            </form>							
         </div>
         <!-- Payment Details Form -->
      </div>
      <div class="col-md-6 col-sm-12 col-xs-12 right_side ordertablegrey">
         
         <div class="common ordertable_div">
			 <div class="common orderdiv mr-bttm-10">
            <h1 class="paymenthdng">Your Order</h1>
         </div>
            <div class="paymentdetailorder">
               <div class="paymentdetailorderinner">
                  <div class="bllomwithlogodetail">
                     <img src="{{product_image_url}}{{packageDetail['icon']}}" class="ordertable_div_img">
                     <p class="tblhdng">Subscriptions <br/>{{packageDetail['name']}}</p>
                  </div>
                  <div class="bloomstorelivecsec">
                     <p><b>Licence</b><br/>{{license_count}}</p>
                  </div>
                  <div class="bloomstorelivecsec">
                     <p><b>Cost</b><br/><b>${{product_price}}/{{package_type == 'Y' ? 'Year' : 'Month'}}</b></p>
                  </div>
               </div>
               <div class="paymetdetailtotalsec">
                  <div class="paymetdetailtotalsecinner">
                     <div class="paytext">
                        <p class="tbldata">Subtotal</p>
                     </div>
                     <div class="payprice">
                        <p class="tbldata">${{total_price}}</p>
                     </div>
                  </div>
                  <div class="paymetdetailtotalsecinner">
                     <div class="paytext">
                        <p class="tbldata">Tax</p>
                     </div>
                     <div class="payprice">
                        <p class="tbldata">0%</p>
                     </div>
                  </div>
                  <div class="paymetdetailtotalsecinner">
                     <div class="paytext">
                        <p class="tbldata">Total</p>
                     </div>
                     <div class="payprice">
                        <p class="tbldata"><b>${{total_price}}</b></p>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</div>
<a href="javascript:void(0)" style="display: none;" data-toggle="modal" data-target="#purchaseModal" class="orderSuccessBtn">Open</a>
<!-- Purchase Modal -->
<div class="modal fade in centerModalNew" id="purchaseModal" data-backdrop="static" data-keyboard="false">
   <div class="modal-dialog prchspopup">
      <div class="modal-content">
         <!-- Modal Header -->
         <div class="modal-header bluemdlhdr"></div>
         <!-- Modal body -->
         <div class="modal-body sucssbody sucssbody2">
            <div class="purchased_logo">
               <img src="{{product_image_url}}{{packageDetail['icon']}}">
            </div>
            <div class="common modalText">
               <h6 class="sucssheading">Success!</h6>
               <p class="tbldata text-center">Thank you for your payment and welcome to {{packageDetail['name']}}! 
                  <br>You can start using your new app right away. 
               </p>
               <p class="tbldata text-center mr-top-30"><a data-dismiss="modal" routerLink="/allot-license" class="sucsslink">Manage your Stores and Licenses</a> </p>
            </div>
            <div class="common text-center mr-top-30">
               <button type="button" class="plcordrbtn" data-dismiss="modal" routerLink="/allot-license" >Ok</button>
            </div>
         </div>
      </div>
   </div>
</div>